<template>
  <div>
    <QueryFrame
      :count="count"
      :current="page"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
>
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>门店名称:</label>
            <storeListSelect
              class="item"
              v-model="query.storeId"
              :multiple="true"
            ></storeListSelect>
          </div>
          <div class="queryItem">
            <label>年度:</label>
            <timeStampDatePicker
              class="item"
              placeholder=" 请选择"
              clearable
              type="year"
              v-model.trim="query.yearVal">
            </timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>申请状态:</label>
            <lk-select  class="item" clearable v-model.trim='query.auditStatus'>
              <lk-option
                v-for="(item) in applyStatusList"
                :key="item.id"
                :value="item.id">{{ item.name }}</lk-option>
              </lk-select>
          </div>
          <div class="queryItem">
            <label>申请时间:</label>
            <timeStampDatePicker
              class="item"
              placeholder=" 请选择"
              clearable
              type='daterange'
              v-model.trim="query.applyTime">
            </timeStampDatePicker>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button v-if="handlePermission('pointApplyCreate')"  type='primary' @click="$router.push({name:'pointApplyCreate'})">+新建申请</lk-button>
        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
    <lk-modal
      v-model="showUploadModal"
      title="上传签收单"
      @on-ok="uploadReceiptPics"
      @on-cancel="cancelUpload">
      <lk-form
          :label-width='100'
          label-position="right">
          <lk-row
            :gutter='10'
            v-for="(item, index) in uploadInfo.receiptPics"
            :key="index"
            >
            <lk-col span="24">
              <lk-form-item :label="index === 0 ? '签收单图片：' : ''">
                <Uploader :able="true" v-model="uploadInfo.receiptPics[index]" @handle="deleteUpload(index)"></Uploader>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='10'>
            <lk-col span="24">
              <lk-form-item :label="!uploadInfo.receiptPics.length? '签收单图片：' : ''">
                <Uploader :able="true" @handle="imgHandle"></Uploader>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='10'>
            <lk-col span="24">
              <lk-form-item style="color: red">请先打印签收单，在患者确认签字后上传签收单图片</lk-form-item>
            </lk-col>
          </lk-row>
        </lk-form>
    </lk-modal>
    <LinkQR035 ref="LinkQR035"></LinkQR035>
  </div>
</template>
<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import points from '../../../services/points';
import utils from '../../../libs/utils';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';
import Uploader from '../../../components/Uploader.vue';
import LinkQR035 from '../../../components/print/LinkQR035.vue';

export default {
  name: 'pointApply',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    Uploader,
    LinkQR035,
  },
  computed: {},
  data() {
    return {
      query: {
        storeId: null,
        yearVal: new Date(),
        applyTime: [],
      },
      showUploadModal: false,
      uploadInfo: {
        exchangeId: null,
        receiptPics: [],
      },
      applyStatusList: [
        { name: '审批中', id: 1 },
        { name: '待签收', id: 2 },
        { name: '审批驳回', id: 3 },
        { name: '已签收', id: 4 },
      ],
      columns: [
        { title: '申请单号', key: 'exchangeCode', minWidth: 116 },
        { title: '申请门店', key: 'storeName', minWidth: 116 },
        { title: '年度', key: 'yearVal', minWidth: 116 },
        { title: '申请时间', key: 'createTime', minWidth: 116 },
        { title: '申请状态', key: 'auditStatusStr', minWidth: 116 },
        { title: '申请积分', key: 'exchangeNum', minWidth: 116 },
        { title: '申请人', key: 'createUserName', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 180,
          render: (h, { row }) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: !this.handlePermission('pointApplyDetail'),
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'pointApplyDetail', params: { id: row.id } });
                },
              },
            }, '查看'),
            row.auditStatus === 2 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.showUploadModal = true;
                  this.uploadInfo.exchangeId = row.id;
                },
              },
            }, '上传签收单') : null,
            row.auditStatus === 2 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$refs.LinkQR035.handlePrint(row.id);
                },
              },
            }, '打印') : null,
          ]),
        },
      ],
      tableData: [],
    };
  },

  methods: {
    imgHandle(src) {
      this.uploadInfo.receiptPics.push(src);
    },
    // 积分申请列表查询
    getData() {
      const params = utils.deepClone(this.query);
      params.page = this.page;
      params.size = this.size;
      if (this.query.applyTime && this.query.applyTime.length === 2) {
        params.applyStartTime = this.query.applyTime[0];
        params.applyEndTime = this.query.applyTime[1];
      }
      if (this.query.yearVal) {
        params.yearVal = new Date(this.query.yearVal).getFullYear();
      }
      this.tableData = [];
      points.storeApplyPointList(params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.count = count;
          list.forEach((item) => {
            const result = Object.assign(item);
            result.createTime = utils.exchangeTimeToSecond(result.createTime);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // 上传签收单
    uploadReceiptPics() {
      if (!this.uploadInfo.receiptPics.length) {
        this.$Message.error('上传图片不得为空');
        return;
      }
      const params = utils.deepClone(this.uploadInfo);
      points.uploadReceipt(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('签收单上传成功');
          this.uploadInfo = { exchangeId: null, receiptPics: [] };
          this.handleSearch(true);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    cancelUpload() {
      this.uploadInfo = { exchangeId: null, receiptPics: [] };
    },
    deleteUpload(index) {
      this.uploadInfo.receiptPics.splice(index, 1);
    },
    clear() {
      this.query = {};
    },
  },
  created() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
.btns{
  margin-bottom: 12px;
  >*{
    margin-right:8px
  }
}

</style>
